export enum ColumnType {
  AccountCode = 1,
  AccountDescription = 2,
  TrialBalance = 3,
  Debit = 4,
  Credit = 5,
}

export class SelectedColumn {
  id?: number;
  type?: ColumnType;
}

export class ColumnDropdown {
  get selectedId(): number | null {
    return this.id;
  }

  set selectedId(value: number) {
    this.id = value;
  }

  get selectedName(): string {
    return this.name;
  }

  set selectedName(value: string) {
    this.name = value;
  }

  greyedOut: boolean = false;

  constructor(
    public id: number | null,
    public type: ColumnType,
    public name: string,
    public selected_by_ai: boolean,
    public label: string
  ) {}
}

export class DropdownOption {
  constructor(
    public name: string,
    public displayName: string,
    public id: number
  ) {}
}

export class ColumnSelection {
  id?: string;
  selected_columns?: SelectedColumn[];
}
